<template>
  <textarea

    v-bind="{...$attrs, value}"
    v-on="{
      ...$listeners,
      input: v=>$emit('input',v.target.value),
    }"

    class="imd-sm-textarea"
  >
    <slot></slot>
  </textarea>
</template>


<script>
export default {
  inheritAttrs: false,
  props: {
    value: [String, Number, Object, Array],
    w100p: { type: Boolean, default: false },
  },
};
</script>